// Configuração da API
// A variável VUE_APP_API_BASE_URL deve ser definida no Cloudflare Pages: Settings > Environment variables
// Exemplo: VUE_APP_API_BASE_URL=https://jrfinance-backend.jmasysc.workers.dev/api
const envApiUrl = process.env.VUE_APP_API_BASE_URL;
const defaultApiUrl = 'https://jrfinance-backend.jmasysc.workers.dev/api';
//const defaultApiUrl = 'https://jrfinance-backend.jmasysc.workers.dev/api';

// Log para debug (apenas em desenvolvimento)
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 API Configuration:', {
    envApiUrl,
    defaultApiUrl,
    finalUrl: envApiUrl || defaultApiUrl
  });
}

export const API_BASE_URL = envApiUrl || defaultApiUrl;

// Chaves do localStorage
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'authToken',
  REFRESH_TOKEN: 'expToken',
  USER: 'user'
} as const;
